export default __webpack_public_path__ + "static/media/secureSSL.9506ef75.png";